import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterLevelFifthSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocationOverview.availableFilters.level_5);
  const selectedOptions = useSelector((state) => state.multiLocationOverview.selectedLevelFifth);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      haveOnSelectChange
      onSelectChange={(data) => dispatch(actionCreators.updateSelectedFifthLevelFilters(data))}
    />
  );
};

export default FilterLevelFifthSelect;
